import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectAxnAdminUserInvitationId } from "@utils/parameter-injector";
import { AxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";

export const getAxnAdminUserInvitationRequest = async (
    axnAdminUserInvitationId: string
): Promise<{ data: AxnAdminUserInvitation, error: any }> => {
    const route = injectAxnAdminUserInvitationId(apiRoutes.axnadminCore.data.axnadminuserinvitationWithId, axnAdminUserInvitationId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};